import { useNavigate } from 'react-router-dom';
import { Button } from 'rsuite';
import TurnBackIcon from '../../assets/icons/turn_back.svg';
interface FofLoginProps {
  image: string;
  text: string;
  redirect: string;
  startFromTop?: boolean;
  backMode?: boolean;
  imageCustomSize?: number;
}
export const FofLogin = (props: FofLoginProps) => {
  const navigate = useNavigate();
  return (
    <>
      <img
        src={props.image}
        alt=""
        className={`w-[90%] mx-auto ${props.startFromTop ? '-' : 'pt-10'}`}
        style={{ width: props.imageCustomSize ? `${props.imageCustomSize}%` : '90%' }}
      />
      <p
        className="text-justify text-md text-[--rs-primary-600] px-5 mt-10"
        style={{ textAlignLast: 'center' }}>
        {props.text}
      </p>
      {props.backMode ? (
        <div className="flex justify-center">
          <Button
            appearance="subtle"
            className="btn-outline mt-6 inline-block"
            onClick={() => {
              navigate(-1);
            }}>
            <img
              className="w-5 ml-1"
              style={{ transform: 'scaleX(-1)' }}
              src={TurnBackIcon}
              alt=""
            />
            بازگشت
          </Button>
        </div>
      ) : (
        <>
          <p
            className="text-justify text-basesm text-[--rs-primary-600] px-5 mt-8"
            style={{ textAlignLast: 'center' }}>
            برای استفاده از این بخش کافیست وارد حساب کاربریتان بشوید. یا اگر هنوز حساب کاربری نساخته
            اید در کمتر از یک دقیقه می توانید آن را ایجاد کنید!
          </p>
          <div className="flex justify-center mb-5">
            <Button
              appearance="primary"
              className="btn-outline mt-6 w-[70%]"
              onClick={() => {
                navigate('/auth/sign-in');
              }}>
              ورود به ناحیه کاربری / ثبت نام
            </Button>
          </div>
        </>
      )}
    </>
  );
};
